module.exports = __webpack_public_path__ + "img/tooltip.abebd428.png";